/** 官网公共部分：顶栏、页脚、404、模型与价格页、模型能力/价格组件（也用于控制台）、示意画面标注。 */
const messages = {
  'nav.models': '模型与价格',
  'nav.docs': 'API 文档',
  'nav.contact': '联系运营',
  'nav.console': '控制台',
  'nav.login': '登录',
  'nav.register': '注册',
  'nav.home': 'aitoken.tools 首页',
  'nav.main': '主导航',
  'nav.openMenu': '打开菜单',
  'nav.siteNav': '站点导航',
  'nav.mobile': '移动端导航',
  'nav.skip': '跳到正文',

  'site.switch': '当前站点：{site}，切换站点',
  'site.isolated': '两站账号、额度、Key 与任务互不相通',
  'site.current': '当前',
  'site.unavailable': '暂未开放',

  'footer.title': '联系与站点信息',
  'footer.tagline': 'Seedance 视频生成 API 中转。一个 API Key 接入，一个任务只结算一次。',
  'footer.announcement': '服务公告：',
  'footer.nav': '页脚导航',
  'footer.changelog': '更新记录',
  'footer.terms': '服务条款',
  'footer.privacy': '隐私政策',
  'footer.otherSite': '{site, select, cn {前往国内站} other {前往海外站}}',
  'footer.city.shanghai': '北京时间',
  'footer.city.singapore': '新加坡时间',
  'footer.city.utc': '协调世界时',
  'footer.tzNote': '账单与日限额按此时区切日',
  'footer.contact': '联系运营',
  'footer.wechat': '微信 {id}',
  'footer.noContact': '注册后在控制台总览查看运营联系方式',
  'footer.cta.a': '联系运营',
  'footer.cta.b': '开通额度',

  'notFound.backHome': '返回首页',
  'notFound.title': '这一页不存在',
  'notFound.body': '链接可能已经失效，或者地址输入有误。任务和素材只能在控制台里查看。',
  'notFound.docs': '查看 API 文档',
  'routeError.title': '页面加载失败',

  'sample.note': '示意画面，由程序生成，并非 Seedance 输出',
  'sample.noteSentence': '示意画面，由程序生成，并非 Seedance 输出。',
  'sample.noteForPrompt': '示意画面，由程序生成，并非 Seedance 输出；对应右侧提示词。',
  'sample.clipLabel': '示意短片：晨雾中的山间小镇',

  'models.meta.title': '模型与价格 · aitoken.tools',
  'models.meta.description': 'Seedance 2.0 与 2.0 Fast 的能力、分辨率与每百万 token 价格，按实际用量结算。',
  'models.title': '模型与价格',
  'models.subtitle': '提交之前，先算清楚冻结多少',
  'models.lead':
    '{site, select, cn {国内站} other {海外站}}当前上架的 Seedance 视频生成模型、可用参数与计价，按 {currency} 结算。',
  'models.lead.me': '下面标出了你的账号是否获得授权。',
  'models.lead.guest': '登录后可以看到你的账号授权状态。',
  'models.cta.console': '在控制台试用',
  'models.cta.register': '注册后试用',
  'models.cta.pricing': '计价规则',
  'models.strip.label': '提示词示意',
  'models.strip.mountain.alt': '晨雾中的山间小镇',
  'models.strip.mountain.prompt': '“晨雾中的山间小镇，镜头缓缓推进”',
  'models.strip.sea.alt': '月光下的海面',
  'models.strip.sea.prompt': '“满月下的海面，碎光一路铺到镜头前”',
  'models.strip.dunes.alt': '傍晚的沙丘',
  'models.strip.dunes.prompt': '“傍晚的沙丘，长影慢慢拉长”',
  'models.strip.bamboo.alt': '薄雾中的竹林',
  'models.strip.bamboo.prompt': '“薄雾里的竹林，斜光穿过竹竿”',
  'models.error': '模型列表暂时无法加载',
  'models.empty.title': '本站暂未上架模型',
  'models.empty.body': '上架后会在这里公布能力与价格。可以先<link>阅读文档</link>完成接入准备。',
  'models.granted': '你的账号已授权',
  'models.notGranted': '未授权，联系运营开通',
  'models.est.title': '算一算这条视频最多冻结多少',
  'models.caps.title': '能力',
  'models.price.title': '计价（每百万输出 token）',
  'models.price.effective': '价格生效于 {date}',

  'est.resolution': '分辨率',
  'est.ratio': '画面比例',
  'est.duration': '时长',
  'est.auto': '自动（按 {max} 秒冻结）',
  'est.seconds': '{s} 秒',
  'est.autoCheckbox': '交给模型决定时长（duration = -1）',
  'est.maxReserve': '提交时最多冻结',
  'est.outputSize': '输出尺寸',
  'est.tokenCap': 'token 上界',
  'est.wh': '宽 × 高',
  'est.formula':
    '{seconds} 秒 × {dims} × {fps} fps ÷ 1024。按文生视频、无视频输入估算；任务结束按实际用量结算，差额退回。',
  'est.requestBody': '对应的请求体',
  'preview.title': '输出画框',
  'preview.auto': '时长自动',

  'mode.text_to_video': '文生视频',
  'mode.first_frame': '首帧生成',
  'mode.first_last_frame': '首尾帧生成',
  'mode.reference': '多模态参考',

  'spec.duration': '{min}–{max} 秒',
  'spec.durationAuto': '{min}–{max} 秒，或由模型自动决定',
  'spec.ratio.adaptive': '自适应',
  'spec.modes': '生成模式',
  'spec.resolution': '分辨率',
  'spec.durationLabel': '时长',
  'spec.ratio': '画面比例',
  'spec.fps': '帧率',
  'spec.inputs': '输入素材',
  'spec.inputs.image': '图片最多 {n} 张，单张 ≤ {size}',
  'spec.inputs.video': '视频最多 {n} 段，合计 ≤ {seconds} 秒',
  'spec.inputs.audio': '音频最多 {n} 段',
  'spec.inputs.audioVisual': '音频最多 {n} 段，需同时提供图片或视频',
  'spec.prompt': '提示词',
  'spec.promptMax': '最多 {n} 字',
  'spec.price.resolution': '分辨率',
  'spec.price.noVideo': '无视频输入',
  'spec.price.withVideo': '含视频输入',
  'spec.price.all': '全部分辨率',
  'spec.note.unit': '单价为每百万输出视频 token；用量 =（输入视频时长 + 输出时长）× 宽 × 高 × 帧率 ÷ 1024。',
  'spec.note.reserve': '提交时按参数上界冻结额度，任务结束按实际用量结算，差额自动释放。',
  'spec.note.rounding': '结算金额向上取整到 {step} {currency, select, CNY {元} other {USD}}。',
  'spec.note.minTokens': '含视频输入时最低按 {n} token 计费。',
  'portraitCallback.title': '认证已提交',
  'portraitCallback.body': '请回到电脑上的素材页，认证结果会自动更新。可以关闭这个页面了。',
};

export default messages;
